'use client';

import { CircularShowcase } from 'components/heroes/CircularShowcase';
import { HeroCategories } from 'components/heroes/HeroCategories';
import { HeroConsentDisclaimer } from 'components/heroes/HeroConsentDisclaimer';
import { HeroSection } from 'components/heroes/HeroSection';
import { useRef } from 'react';

const Hero = () => {
  const sectionRef = useRef<HTMLElement>(null);

  const clickHandler = () => {
    sectionRef.current?.scrollIntoView({
      behavior: 'smooth',
    });
  };

  return (
    <main>
      <HeroSection onClick={clickHandler} />
      <HeroCategories ref={sectionRef} />
      <CircularShowcase />
      <HeroConsentDisclaimer align="center" padding light />
    </main>
  );
};

export default Hero;
